import { Component } from '@angular/core';

@Component({
  selector: 'app-helper-banner',
  templateUrl: './helper-banner.component.html',
  standalone: true,
  styleUrl: './helper-banner.component.scss'
})
export class HelperBannerComponent {

}
